<!-- Section Régulation -->
<app-collapse
  [title]="'P00043.status.regulation' | translate"
  [warning]="regulationHasAlarm"
>
  <div slot="contenu">
    <app-display-rubrique-status-on-off
      [title]="'P00043.status.etatPilotagePAC' | translate"
      [value]="getValue('paSEtat') !== 0"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00043.status.arretDeLaCommande' | translate"
      [warning]="regulationHasAlarm"
      [icon]="'fa-exclamation-triangle'"
      text="-"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status-on-off
        [title]="'P00043.status.prioritePAC' | translate"
        [value]="getValue('paSMiseEnRouteFiltrationPriorite') === 1"
      />

      <app-display-rubrique-status-on-off
        [title]="'P00043.status.autoMaintienFiltration' | translate"
        [value]="getValue('paSMiseEnRouteFiltrationAutoMaintien') === 1"
      />

      <app-display-rubrique-status
        [title]="'P00043.status.mesureTempEauDispo' | translate"
        [value]="
          getValue('paSTEauReferenceDisponible') === 1
            ? ('ok' | translate)
            : ('P00043.status.indisponible' | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P00043.status.detectionDebitReference' | translate"
        [value]="debitDetectionReference"
      />
    }
  </div>
</app-collapse>

<!-- Section Produit -->
<app-collapse
  [title]="'P00043.status.product' | translate"
  [warning]="presenceProduit === 2"
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning
      [title]="'P00043.status.presenceDuProduit' | translate"
      [warning]="presenceProduit === 2"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status
      [title]="'P00043.status.etatContactSec' | translate"
      [value]="
        getValue('paSEtatContactSec') === 0
          ? ('P00043.status.ouvert' | translate)
          : ('P00043.status.ferme' | translate)
      "
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P00043.status.nombreCommutationsRelais' | translate"
        [value]="getValue('paSNombreCommutationsRelais') + ''"
      />

      <app-display-rubrique-status-on-off
        [title]="'P00043.status.etatBouton' | translate"
        [value]="getValue('paSEtatBouton') === 1"
      />

      <app-display-rubrique-status
        [title]="'P00043.status.compteurBouton' | translate"
        [value]="getValue('paSCompteurBouton') + ''"
      />

      <app-display-rubrique-status
        [title]="'P00043.status.tempsSousTension' | translate"
        [value]="transformHourToDayHourLocal(getValue('paSTempsSousTension'))"
      />
    }
  </div>
</app-collapse>
